import { render } from "./loadBar.vue?vue&type=template&id=24589eff&scoped=true"
import script from "./loadBar.vue?vue&type=script&lang=js"
export * from "./loadBar.vue?vue&type=script&lang=js"

import "./loadBar.vue?vue&type=style&index=0&id=24589eff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24589eff"]])

export default __exports__